import { IRole } from '@/@data'
import { Typography, Box } from '@mui/material'
import { getRoleIcon, getRoleColor } from '@/utils/getRoleIcon'

export const RoleLabel = ({ role }: { role: IRole }) => {
  const icon = getRoleIcon(role.name)
  const color = getRoleColor(role.name)

  return (
    <Box display='flex' alignItems='center' gap={1} className='d-flex gap-2 '>
      <i
        className={icon}
        style={{
          color: color
        }}
      />
      <Typography variant='body2' color='text.primary'>
        {role.name}
      </Typography>
    </Box>
  )
}
